import type { FunctionalComponent } from "preact";
import { useState, useEffect } from "preact/hooks";
import { type ArticleModel, relatedArticlesBlockService } from "./magazine.service";
import { relatedArticles } from "./Components/related-articles";

export interface RelatedArticlesContainerProps {
  pageIdList: string;
  showIngress: boolean;
  relatedTitle: string;
}

export const RelatedArticlesContainer: FunctionalComponent<RelatedArticlesContainerProps> = ({
  pageIdList,
  showIngress,
  relatedTitle,
}: RelatedArticlesContainerProps) => {
  const [articles, setArticles] = useState(new Array<ArticleModel>());

  const getArticles = async (): Promise<void> => {
    const magazineModel = await relatedArticlesBlockService(pageIdList);
    setArticles(magazineModel.pageList);
  };

  useEffect(() => {
    void getArticles();
  }, []);

  return relatedArticles({ articles, showIngress, relatedTitle });
};
